module.exports = __webpack_public_path__ + "img/10.507d6b21.png";